import { motion } from "framer-motion";
import { SERVICE_PHOTO_CARDS, SERVICE_EXTRA } from "../data";

export const Services = () => {
  return (
    <section
      id="uslugi"
      data-testid="services-section"
      className="bg-[#F4F4F5] py-16 md:py-24 border-y-2 border-[#09090B]"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="max-w-2xl">
          <span className="font-anton uppercase text-[#DC2626] tracking-widest text-sm">
            Usługi
          </span>
          <h2 className="font-anton uppercase text-[#09090B] text-4xl md:text-5xl mt-3 leading-tight">
            Co dla Ciebie zrobimy
          </h2>
        </div>

        {/* Photo-backed service cards */}
        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {SERVICE_PHOTO_CARDS.map((s, i) => (
            <motion.div
              key={s.title}
              data-testid={`service-card-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: (i % 4) * 0.07 }}
              className="group relative border-2 border-[#09090B] overflow-hidden bg-[#09090B] hover:shadow-[8px_8px_0_0_rgba(220,38,38,1)] transition-all duration-300"
            >
              <div className="relative h-56 md:h-72 overflow-hidden">
                <img
                  src={s.img}
                  alt={s.title}
                  className="absolute inset-0 w-full h-full object-cover opacity-80 group-hover:opacity-100 group-hover:scale-105 transition-all duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#09090B] via-[#09090B]/40 to-transparent" />
                <span className="absolute top-3 left-3 bg-[#DC2626] text-white font-anton uppercase text-xs tracking-widest px-3 py-1">
                  {s.label}
                </span>
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <h3 className="font-anton uppercase text-white text-xl leading-tight">
                    {s.title}
                  </h3>
                  <p className="mt-1.5 text-zinc-300 text-sm leading-snug">
                    {s.description}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Secondary services */}
        <div className="mt-6 grid sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {SERVICE_EXTRA.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.title}
                data-testid={`service-extra-${i}`}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.35, delay: (i % 4) * 0.06 }}
                className="bg-white border-2 border-[#09090B] p-5 flex flex-col hover:-translate-y-1 hover:shadow-[6px_6px_0_0_rgba(9,9,11,1)] transition-all duration-200"
              >
                <div className="w-11 h-11 bg-[#09090B] flex items-center justify-center mb-4">
                  <Icon className="text-white" size={22} strokeWidth={2.2} />
                </div>
                <h3 className="font-anton uppercase text-[#09090B] text-lg leading-tight">
                  {s.title}
                </h3>
                <p className="mt-2 text-zinc-600 text-sm leading-relaxed">
                  {s.description}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
